import React from 'react'

const Disclaimer = () => <span className='vega info disclaimer'>ⓘ dollar amounts may be in cents</span>

export default Disclaimer
